import { Link } from "react-router-dom";
import { ArrowRight, Navigation } from "lucide-react";
import { MAPS_URL } from "@/components/home/StoreInfo";

export const HomeHero = () => (
  <section className="relative overflow-hidden bg-[#FBFBF8]" data-testid="home-hero">
    <img src="/aim-hero.jpg" alt="Deportistas: fútbol, running, ciclismo, tenis, natación y baloncesto"
      className="w-full aspect-[16/10] lg:aspect-[16/7] object-cover object-[75%_center] xl:absolute xl:inset-0 xl:h-full xl:aspect-auto xl:object-right" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-10 xl:py-40">
      <div className="max-w-xl">
        <p className="eyebrow fade-up">Tu tienda de deportes · Olula del Río</p>
        <h1 className="mt-5 font-heading text-5xl sm:text-6xl lg:text-8xl font-black uppercase tracking-tight leading-[0.9] text-brand-dark fade-up" style={{ animationDelay: "80ms" }}>
          Más deporte.<br /><span className="text-verde">Más vida.</span>
        </h1>
        <p className="mt-6 max-w-md text-slate-600 fade-up" style={{ animationDelay: "160ms" }}>
          Calzado, ropa y accesorios deportivos para acompañarte en cada reto. Ven a conocernos a la tienda o compra online con Bizum o transferencia.
        </p>
        <div className="mt-8 flex flex-wrap gap-2 fade-up" style={{ animationDelay: "200ms" }}>
          {[["calzado", "Calzado"], ["ropa", "Ropa"], ["accesorios", "Accesorios"]].map(([id, l]) => (
            <Link key={id} to={`/tienda?category=${id}`} className="h-9 px-4 rounded-full border border-slate-300 bg-white/80 text-sm font-semibold grid place-items-center hover:border-brand hover:text-brand transition-colors" data-testid={`hero-chip-${id}`}>{l}</Link>
          ))}
        </div>
        <div className="mt-8 flex flex-wrap gap-3 fade-up" style={{ animationDelay: "240ms" }}>
          <Link to="/tienda" className="btn-primary" data-testid="hero-shop-button">Comprar ahora <ArrowRight className="w-4 h-4" /></Link>
          <Link to="/outlet" className="btn-primary btn-verde" data-testid="hero-outlet-button">Ver outlet</Link>
          <a href={MAPS_URL} target="_blank" rel="noreferrer" className="btn-outline" data-testid="hero-directions-button"><Navigation className="w-4 h-4" /> Cómo llegar</a>
        </div>
      </div>
    </div>
  </section>
);
